const RelatorioPesquisaSatisfacaoHome = () =>
  import(/* webpackChunkName: "group-satisfaction-research"*/ '../views/RelatorioPesquisaSatisfacaoHome')

import { permissoesRelatoriosPesquisa } from '../../../../../utils/permissoesPesquisaSatisfacao'

export default [
  {
    path: 'pesquisa-satisfacao',
    component: RelatorioPesquisaSatisfacaoHome,
    meta: { requiresAuth: true, permissions: [...permissoesRelatoriosPesquisa] },
    name: 'relatorioPesquisa',
  },
]
